import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar.jsx';
import Header from './Header.jsx';
import AIPanel from '../shared/AIPanel.jsx';

export default function AppLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [aiOpen, setAiOpen] = useState(false);

  const sidebarWidth = sidebarCollapsed ? 56 : 224;

  return (
    <div className="app-layout">
      <Sidebar collapsed={sidebarCollapsed} />

      <div className="app-main" style={{ marginLeft: sidebarWidth }}>
        <Header
          onToggleSidebar={() => setSidebarCollapsed(c => !c)}
          onOpenAI={() => setAiOpen(true)}
        />

        <main className="app-content">
          <Outlet />
        </main>
      </div>

      {/* AI panel — slides over content, does not squeeze layout */}
      <AIPanel open={aiOpen} onClose={() => setAiOpen(false)} />

      {/* Tablet FAB */}
      {!aiOpen && (
        <button className="ai-fab" onClick={() => setAiOpen(true)} aria-label="Open AI assistant">
          ✦
        </button>
      )}

      <style>{`
        .app-layout {
          min-height: 100vh;
          background: var(--bg);
        }

        .app-main {
          transition: margin-left var(--transition);
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }

        .app-content {
          margin-top: var(--header-height);
          padding: 24px;
          flex: 1;
          max-width: 1400px;
          width: 100%;
        }

        .ai-fab {
          display: none;
          position: fixed;
          bottom: 24px;
          right: 24px;
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: var(--pld-green);
          color: var(--pld-yellow);
          font-size: 22px;
          box-shadow: var(--shadow-lg);
          z-index: 199;
          transition: transform var(--transition), box-shadow var(--transition);
        }
        .ai-fab:hover { transform: scale(1.08); box-shadow: 0 10px 28px rgba(0,0,0,.2); }

        @media (max-width: 1024px) {
          .ai-fab { display: flex; align-items: center; justify-content: center; }
          .app-main { margin-left: 56px !important; }
          .app-content { padding: 16px; }
        }

        @media (max-width: 480px) {
          .app-content { padding: 12px; }
        }
      `}</style>
    </div>
  );
}
